module.exports = __webpack_public_path__ + "bower_components/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./bower_components/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.svg
 ** module id = 231
 ** module chunks = 1
 **/